export const isFilterSelected = (filter, selectedFilters) => selectedFilters.includes(filter)

export const getSelectedFilterCount = (filters, selectedFilters) => filters?.filter(filter => isFilterSelected(filter, selectedFilters)).length
